import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AiOutlineDoubleLeft } from 'react-icons/ai';
import axios from 'config/axios';
import Table from 'components/Table';

import './index.css';

type StudentsProps = {
    students: any[];
    setStudents: ({}) => void;
    updateStudents: boolean;
};

function Students({
    students,
    setStudents,
    updateStudents
}: StudentsProps) {
    const navigate = useNavigate();
    const { classId } = useParams();

    const addStudent = (studentId: string) => {
        axios.post('tutors/classes/student/add/', {
                classId: classId,
                studentId: studentId
            })
            .then(res => {
                setStudents(res.data.students);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const removeStudent = (studentId: string) => {
        axios.post('tutors/classes/student/remove/', {
                classId: classId,
                studentId: studentId
            })
            .then(res => {
                setStudents(res.data.students);
            })
            .catch(error => {
                console.log(error);
            });
    }

    return (
        <div className='class-students'>
            {updateStudents
            ?   <Table
                    className='class-students__table'
                    header={['', 'ID', 'Name', 'Student Email']}
                    rows={students.filter(student => student.inClass).map(student => ([
                        <p className='class-students__remove'>Remove</p>,
                        student.studentId,
                        `${student.firstName} ${student.lastName}`,
                        student.email
                    ]))}
                    onSelectCell={students.filter(student => student.inClass).map(student => ([
                        () => removeStudent(student.firebaseId),
                        null,
                        null,
                        null
                    ]))}
                />
            :   <Table
                    className='class-students__table'
                    header={['ID', 'Name', 'Student Email']}
                    // columnTypes={['number', 'string', 'string']}
                    rows={students.filter(student => student.inClass).map(student => ([
                        student.studentId,
                        `${student.firstName} ${student.lastName}`,
                        student.email
                    ]))}
                    onSelectCell={students.filter(student => student.inClass).map(student => ([
                        null,
                        () => navigate(`/students/${student.id}`),
                        null
                    ]))}
                />
            }
            {updateStudents && <>
                <AiOutlineDoubleLeft className='class-students__arrow' />
                <Table
                    className='class-students__table'
                    header={['', 'ID', 'Name', 'Student Email']}
                    rows={students.filter(student => !student.inClass).map(student => ([
                        'Add',
                        student.studentId,
                        `${student.firstName} ${student.lastName}`,
                        student.email
                    ]))}
                    onSelectCell={students.filter(student => !student.inClass).map(student => ([
                        () => addStudent(student.firebaseId),
                        null,
                        null,
                        null
                    ]))}
                />
            </>}
        </div>
    );
}

export default Students;